<template>
  <DashboardLayout>
    <template #top-left>
      <GrafanaChartCard v-bind="config.topLeft" />
    </template>
  </DashboardLayout>
</template>

<script>
import DashboardLayout from '@/components/dashboard/DashboardLayout.vue'
import { DASHBOARD_CONFIGS } from '@/components/dashboard/dashboardConfig.js'
import GrafanaChartCard from '../components/dashboard/GrafanaChartCard.vue'

export default {
  name: 'DashboardPage4',
  components: {
    DashboardLayout,
    GrafanaChartCard
  },
  computed: {
    config() {
      return DASHBOARD_CONFIGS.page4
    }
  }
}
</script>
